<div bsModal #newniche="bs-modal" id="newniche" class="modal fade" (onShown)="onShown()" role="dialog" aria-labelledby="newniche" aria-hidden="true" [config]="{backdrop: 'static'}">
    <div class="modal-dialog">

        <div #modalContent class="modal-content">
            <div class="modal-header text-center">
                <button type="button" class="close" (click)="close()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h2 class="modal-title text-center">New Niche</h2>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col-12">
                        <label>Name</label>
                        <input type="type" name="name" value="" placeholder="Niche name" />
                    </div>
                </div>
            </div>

            <div class="modal-footer text-right">
                <input (click)="close()" type="button" class="btn" name="close" value="Cancel" />
                <input type="button" class="btn btn-primary waves-effect" value="Ok" />
            </div>
        </div>
    </div>
</div>
